import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0374aebc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sortIcon = _resolveComponent("sortIcon")!
  const _component_CustomDropDown = _resolveComponent("CustomDropDown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      id: _ctx.idPopover,
      class: _normalizeClass(["default-button button-filter filter tw-px-4 tw-py-4 tw-flex tw-items-center tw-bg-[white]", {
      'disable-button': !_ctx.active,
      'border-button': _ctx.hasBorder,
      'margin-mobile': _ctx.hasBorder,
      '!tw-bg-[#211F58]': _ctx.onHoverStatus,
    }]),
      onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal(true)))
    }, [
      _createVNode(_component_sortIcon, {
        color: `${_ctx.onHoverStatus ? 'white' : '#211F58'}`
      }, null, 8, ["color"]),
      _createElementVNode("span", {
        class: _normalizeClass(`tw-pl-2 ${
        _ctx.onHoverStatus ? 'tw-text-[#FFF]' : 'tw-text-[#211F58] '
      } tw-text-[10px] text-sort`)
      }, _toDisplayString(_ctx.getUiText("app-notification-sort-1")), 3)
    ], 42, _hoisted_1),
    _createVNode(_component_CustomDropDown, {
      "id-popover": _ctx.idPopover,
      class: _normalizeClass([!_ctx.showMoreActions ? 'tw-invisible' : '', "notification-sort"]),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal(false))),
      onOnHover: _ctx.onHover
    }, _createSlots({ _: 2 }, [
      (_ctx.showMoreActions)
        ? {
            name: "default",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["id-popover", "class", "onOnHover"])
  ], 64))
}